/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_ReconstructedInputs */



/**
* | output |
* | --- |
* | "the event was rebuilt from the TWDA, which already holds it" |
*
* @param {Twda_Reason_ReconstructedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_reconstructed = /** @type {((inputs?: Twda_Reason_ReconstructedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_ReconstructedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ce tournoi a été reconstitué depuis le TWDA, qui le contient déjà")
	if (locale === "es") return /** @type {LocalizedString} */ ("el torneo se reconstruyó a partir del TWDA, que ya lo contiene")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o torneio foi reconstruído a partir do TWDA, que já o contém")
	if (locale === "it") return /** @type {LocalizedString} */ ("il torneo è stato ricostruito dal TWDA, che lo contiene già")
	return /** @type {LocalizedString} */ ("the event was rebuilt from the TWDA, which already holds it")
});